<template>
  <div class="fast-search secondary lighten-2">
    <category-title :category="category" />
    <category-block
      :target="category"
      :container="false"
      position="position1"
      class="category-block category-block-1"
    />
    <div class="secondary lighten-2">
      <v-container>
        <div class="search-result" v-for="q in query" :key="q">
          <SimpleProductListSlider
            :query="q"
            :paginationClass="'swiper-pagination-' + q"
          />
          <v-divider class="mb-6"></v-divider>
        </div>
      </v-container>
    </div>
    <category-block
      :target="category"
      :container="false"
      position="position2"
      class="category-block category-block-2"
    />
  </div>
</template>
<script>
import SimpleProductListSlider from "@/components/product/SimpleProductListSlider.vue";
import CategoryTitle from "@/components/category/CategoryTitle.vue";

import categoryMixins from "~/mixins/category";

export default {
  name: "FastSearch",
  components: {
    SimpleProductListSlider,
    CategoryTitle
    // Breadcrumb
  },
  mixins: [categoryMixins],
  data() {
    return {
      query: []
    };
  },
  methods: {
    getQueryParams() {
      this.query = this.$route.query.q;
    }
  },
  async created() {
    this.getQueryParams();
  },
  watch: {
    async "$route.query"() {
      this.getQueryParams();
    }
  }
};
</script>
